<template>
  <div class="about">
    <Header
    :headerBgc="state.headerBgc"
    :showLogo="state.showLogo"
    :boxShadows="state.boxShadows"
    :title-color="state.titleColor"
    @titleClick="titleClick"
    @menuClick="menuClick"/>
    <div class="about_con">
      <div class="top">
        <p data-aos="fade-up" data-aos-duration="1000">{{ $t('about.pageTitle') }}</p>
      </div>
      <div class="list">
        <div class="name yourButton" :class="state.active===index?'act':''" @click="handleList(index)" v-for="(item,index) in tabList" :key="item.id">{{item.name}}</div>
      </div>
      <!-- 企业介绍 -->
      <div class="com_desc" v-show="state.active===0">
        <div class="com">
          <div class="com_list" :class="state.actCom===index?'actCom':''" @click="handleCom(index)" v-for="(item,index) in companyList" :key="item.id">{{item.comName}}</div>
        </div>
        <div class="down">
          <div class="left">
            <div class="text" v-show="state.actCom===0" data-aos="flip-up">
              {{ $t('about.enterprise.desc.genebio1') }}<br/>
              {{ $t('about.enterprise.desc.genebio2') }}<br/>
              {{ $t('about.enterprise.desc.genebio3') }}
            </div>
            <div class="text" v-show="state.actCom===1" data-aos="flip-up">
              {{ $t('about.enterprise.desc.huiKang1') }}<br/>
              {{ $t('about.enterprise.desc.huiKang2') }}<br/>
              {{ $t('about.enterprise.desc.huiKang3') }}
            </div>
            <div class="text" v-show="state.actCom===2" data-aos="flip-up">
              {{ $t('about.enterprise.desc.zhongShan') }}
            </div>
            <div class="btn_con">
                <img class="left" v-if="state.actCom!==0" @click="prevCom" src="/mimg/left_act.png" alt="">
                <img class="left" v-else @click="prevCom" src="/mimg/left.png" alt="">
                <img class="right" v-if="state.actCom===2"  @click="nextCom" src="/mimg/right.png" alt="">
                <img class="right" v-else  @click="nextCom" src="/mimg/right_act.png" alt="">
            </div>
          </div>
          <div class="right">
            <img src="@/assets/img/qiye.png" alt="">
          </div>
        </div>
        <Number/>
      </div>
      <!-- 明星团队 -->
      <div class="star_team" v-show="state.active===1">
        <div class="left">
          <img src="@/assets/img/boss.png" alt="">
        </div>
        <div class="right">
          <div class="title">{{ $t('about.starTeam.founderName') }}</div>
          <div class="desc">
            {{ $t('about.starTeam.founderDesc.p1') }}<br/>
            {{ $t('about.starTeam.founderDesc.p2') }}<br/>
            {{ $t('about.starTeam.founderDesc.p3') }}
          </div>
        </div>
      </div>
      <!-- 发展历程 -->
      <div class="develop" v-show="state.active===2">
        <div class="fz">{{ $t('about.development.title') }}</div>
         <div class="act_year" data-aos="fade-up" data-aos-duration="1000">{{ timelineData[state.actY].year }}</div>
         <HorizonTimeLine :timelineData="timelineData" :activeYear="state.actY" @changeY="changeY" ref="lineChange"/>
         <div class="year_text" data-aos="fade-up"> {{ timelineData[state.actY].text }} </div>
        <div class="foo">
          <div class="le">
            <img v-if="state.actY!==0" @click="prevYear" src="/mimg/left_act.png" alt="">
            <img v-else src="/mimg/left.png" alt="">
          </div>
          <div class="mi" v-for="(item,index) in state.years" :key="index">
            <div class="te" :class="state.actY===index?'nu':''" @click="handleYear(index)">{{ item }}</div>
            <div :class="state.actY===index?'line':''"></div>
          </div>
          <div class="ri">
            <img v-if="state.actY===5"  src="/mimg/right.png" alt="">
            <img v-else @click="nextYear" src="/mimg/right_act.png" alt="">
          </div>
        </div>
      </div>
      <!-- 荣誉资质 -->
      <div class="honor" v-show="state.active===3">
         <div class="zhuanli">
          <div class="title">{{ $t('about.honor.patentTitle') }}</div>
          <div class="img_com">
            <div class="item">
              <div class="img_box" data-aos="flip-left">
                <img src="@/assets/img/patent/1.png"  alt="">
              </div>
              <div class="name">{{ $t('about.honor.patents.innovationChannel') }}</div>
            </div>
            <div class="item">
              <div class="img_box">
               <img src="@/assets/img/patent/2.png" alt="">
              </div>
              <div class="name">{{ $t('about.honor.patents.iso13485') }}</div>
            </div>
            <div class="item">
              <div class="img_box">
                <img src="@/assets/img/patent/3.png" alt="">
              </div>
              <div class="name">{{ $t('about.honor.patents.miR92aRegistration') }}</div>
            </div>
            <div class="item">
              <div class="img_box">
               <img src="@/assets/img/patent/4.png" alt="">
               </div>
              <div class="name">{{ $t('about.honor.patents.euCE') }}</div>
            </div>
          </div>
         </div>
         <div class="rongyu">
          <div class="title">{{ $t('about.honor.awardTitle') }}</div>
          <div class="swiper">
            <el-carousel height="80vh" :autoplay="true" :interval="300000" :loop="true" arrow="always">
              <el-carousel-item v-for="(item, index) in 2" :key="item">
                <div class="one" v-show="index===0">
                  <div class="up">
                    <img  src="@/assets/img/awards/2.png" alt="">
                    <img class="mar"  src="@/assets/img/awards/serve.jpg" alt="">
                    <img src="@/assets/img/awards/1.png" alt="">
                  </div>
                  <div class="lower">
                    <img src="@/assets/img/awards/4.png" alt="">
                    <img class="marr" src="@/assets/img/awards/5.png" alt="">
                    <img src="@/assets/img/awards/6.png" alt="">
                    <img class="marr" src="@/assets/img/awards/7.png" alt="">
                    <img src="@/assets/img/awards/8.png" alt="">
                  </div>
                </div>
                <div class="two" v-show="index===1">
                  <div class="up">
                    <img src="@/assets/img/awards/9.png" alt="">
                    <img class="marr" src="@/assets/img/awards/10.png" alt="">
                    <img src="@/assets/img/awards/11.png" alt="">
                    <img class="marr" src="@/assets/img/awards/12.png" alt="">
                    <img src="@/assets/img/awards/13.png" alt="">
                  </div>
                  <div class="lower">
                    <img style="margin-right: 24px;" src="@/assets/img/awards/14.png" alt="">
                    <img src="@/assets/img/awards/3.png" alt="">
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
         </div>
      </div>
      <!-- 联系我们 -->
      <div class="we" v-show="state.active===4">
        <img src="@/assets/img/callme.png" alt="">
      </div>
    </div>
    <NewFooter />
  </div>
</template>

<script setup>
import {reactive,onMounted,onUnmounted,ref,computed} from 'vue'
import { useAppStore } from '../store/app'
const router = useRouter()
const route =useRoute()
const { t } = useI18n()
const localePath = useLocalePath()
const { $aos } = useNuxtApp()
const { activeNum,setActive } = useAppStore()

useSeoMeta({
  title: () => t('about.seoTitle'),
  description: () => t('about.seoDescription'),
  ogTitle: () => t('about.seoTitle'),
  ogDescription: () => t('about.seoDescription'),
  ogType: 'website',
})
// 发展历程事件文案从语言包读取，语言切换时自动更新
const timelineData = computed(() => [2013, 2015, 2018, 2019, 2021, 2022].map((year) => ({
  year,
  text: t(`about.development.events.${year}`),
})))
const lineChange =ref(null)
const tabList = computed(() => [
  { name: t('about.enterprise.title'), id: 1 },
  { name: t('about.starTeam.title'), id: 2 },
  { name: t('about.development.title'), id: 3 },
  { name: t('about.honor.title'), id: 4 },
  { name: t('about.contact.title'), id: 5 },
])

const companyList = computed(() => [
  { comName: t('about.enterprise.companyNames.genebio'), id: 1 },
  { comName: t('about.enterprise.companyNames.huiKang'), id: 2 },
  { comName: t('about.enterprise.companyNames.zhongShan'), id: 3 },
])

const state =  reactive({
  headerBgc:'',
  showLogo:true,
  titleColor:'#fff',
  boxShadows:'',
  active:0,
  actCom: 0,
  actY:5,
  years:[2013,2015,2018,2019,2021,2022],
})
const handleList=(index)=>{
  state.active = index
  setActive(index)
}
const handleCom=(index)=>{
  state.actCom = index
  // v-show 切换后让 AOS 重新计算，避免新显示的内容保持隐藏状态
  $aos().refresh()
}
const changeY=(index)=>{
  state.actY =index
  $aos().refresh()
}
const prevCom=()=>{
   if (state.actCom > 0) {
      state.actCom--
      $aos().refresh()
  }
}
const nextCom=()=>{
  if (state.actCom < state.comList.length - 1) {
    state.actCom++
    $aos().refresh()
  }
}
const prevYear=()=>{
   if (state.actY > 0) {
      state.actY--
      lineChange.value.onClickYear(state.actY)
      $aos().refresh()
  }
}
const nextYear=()=>{
  if (state.actY < state.years.length - 1) {
    state.actY++
    lineChange.value.onClickYear(state.actY)
    $aos().refresh()
  }
}
const handleYear =(index)=>{
  state.actY = index
  lineChange.value.onClickYear(state.actY)
  $aos().refresh()
}
const titleClick=(id)=>{
  if (id == 11) {
    setActive(0)
      navigateTo(localePath(`/about`))
    }else if(id==22){
      setActive(0)
      navigateTo(localePath(`/product`))
    } else if (id == 33) {
      navigateTo(localePath(`/health`))
    } else if (id == 44) {
      setActive(0)
      navigateTo(localePath(`/contact`))
    } else {
      navigateTo(localePath(`/newsCenter`))
    }
}
const menuClick =(e,path)=>{
  let id = +e
    navigateTo(path)
    if(path.includes('/about')){
      state.active = id-1
      setActive(+id-1)
      return
    }
    if(path.includes('/product')){
      state.active = id-6
      setActive(+id-6)
      return
    }
    if(path.includes('/health')){
      state.active = 0
      setActive(0)
      return
    }
    if(path.includes('/contact')){
      state.active = id-13
      setActive(+id-13)
      return
    }
}
function handleScroll() {
  let top = Math.floor(document.documentElement.scrollTop || document.body.scrollTop);
  if(top>=80){
    state.headerBgc='#fff'
    state.showLogo=false
    state.titleColor="#000"
    state.boxShadows='0px 1px 8px 0px rgba(0,0,0,0.09)'
  } else{
    state.headerBgc=''
    state.showLogo=true
    state.titleColor="#fff"
    state.boxShadows=''
  }
}
onMounted(()=>{
    const tab = Number(route.query.tab)
    state.active = (!isNaN(tab) && tab >= 0 && tab < state.list.length) ? tab : activeNum
    setActive(state.active)
    $aos().init({
      easing: 'ease-out-back',
      duration: 2000,
      once:true
  })
  window.addEventListener("scroll", handleScroll)
})
onUnmounted(()=>{
 window.removeEventListener('scroll', handleScroll)
 localStorage.removeItem('counter')
})
</script>

<style lang="less" scoped>
.about{
  .about_con{
    width: 100%;
    background-color: #fff;
    position: relative;
    .top{
      background: url('../assets/img/aboutt.png');
      background-size: cover;
      background-position: center;
      width: 100%;
      height: 200px;
      p{
        font-size: 18px;
        // text-shadow: 2px 2px 2px #888;
        text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
        font-weight: 700;
        color: #fff;
        padding-top: 80px;
        text-align: center;
        transition: transform 0.3s ease, color 0.3s ease;
      }
      .p_act{
        transform: translateY(-30px); /* 鼠标经过时上移文字 */
        color: #333; /* 鼠标经过时加深文字颜色 */
      }
    }
    .list{
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0px 1px 20px 0px rgba(0, 0, 0, 0.13);
      height: 34px;
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
      .name{
        background-color: #fff;
        width: 120px;
        height: 34px;
        line-height: 34px;
        text-align: center;
        cursor: pointer;
        color: #5A5A5A;
        transition: transform 0.3s ease, background-color 0.7s ease; /* 添加过渡效果 */
        &:hover{
          background-color: #00A0E9;
          color: #fff;
        }
      }
      .act{
        background-color: #00A0E9;
        color: #fff;
      }
    }
     // 企业介绍
    .com_desc{
      padding-top: 20px;
      .com{
      display: flex;
      align-items: center;
      margin-left: 80px;
      margin-top: 40px;
      .com_list{
        margin-right: 40px;
        text-align: center;
        cursor: pointer;
        font-size: 14px;
        font-family: Alibaba PuHuiTi;
        font-weight: bold;
        color: #DDDDDD;
      }
      .actCom{
        color: #00A0E9;
      }
    }
    .down{
      display: flex;
      margin-left: 80px;
      .left{
        margin-right: auto;
        .text{
          width: 361px;
          height: 103px;
          line-height: 16px;
          margin-top: 24px;
        }
        .btn_con{
          margin-top: 40px;
          .left{
            margin-right: 12px;
          }
          img{
            width: 24px;
            height: 24px;
            cursor: pointer;
          }
        }
      }
      .right{
        img{
          width: 268px;
          height: 247px;
        }
      }
    }
    }
    // 明星团队
    .star_team{
       background: url('../assets/img/starbg.png');
        background-size: cover;
        background-position: center;
        width: 100%;
        // height: 400px;
        display: flex;
        justify-content: center;
        padding-top: 60px;
        .left{
          width: 200px;
          height: 281px;
          margin-right: 20px ;
          animation: moveLeft 1.2s ease-in-out forwards;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .right{
          animation: moveRight 1.2s ease-in-out forwards;
          .title{
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 20px;
          }
          .desc{
            /* 改用 min-height 替代固定 height，避免英文等较长文案
               最后一行被容器高度截断；高度随内容自适应 */
            width: 400px;
            max-width: 50vw;
            min-height: 132px;
            line-height: 20px;
            padding-bottom: 40px;
            word-break: break-word;
          }
        }
        @keyframes moveLeft {
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(0);
  }
  70% {
    transform: translateX(-6px);
  }
  80% {
    transform: translateX(10px);
  }
  90% {
    transform: translateX(-3px);
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes moveRight {
  0% {
    transform: translateX(100%);
  }
  50% {
    transform: translateX(0);
  }
  70% {
    transform: translateX(6px);
  }
  80% {
    transform: translateX(-10px);
  }
  90% {
    transform: translateX(3px);
  }
  100% {
    transform: translateX(0);
  }
}
      }
    .develop{
        // background-color: blue;
        // height: 500px;
        width: 100%;
        .fz{
          font-size: 16px;
          font-weight: bold;
          width: 100%;
          text-align: center;
          margin-top: 50px;
        }
        .act_year{
          text-align: center;
          font-size: 70px;
          font-weight: 900;
          margin-bottom: -50px;
          background: linear-gradient(to bottom, #eff3f6, #fcfdfe13);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          animation: scale-up 1s ease-in-out forwards;
        } 
        @keyframes scale-up {
            from {
              transform: scale(0);
            }
            to {
              transform: scale(1);
            }
          }
        .year_text{
          text-align: center;
          margin: 30px 0 40px 0;
          font-size: 11px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
        }
        .foo{
          background: url('../assets/img/fz.png');
          background-size: cover;
          // background-position: center;
          width: 100%;
          height: 123px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          .le{
            img{
              width: 18px;
              height: 18px;
              cursor: pointer;
            }
          }
          .mi{
            font-size: 10px;
            color: #C3C3C3;
            .te{
              cursor: pointer;
            }
            .nu{
              color: #00A0E9;
              font-weight: bold;
            }
            .line{
              margin-top: 3px;
              width: 19px;
              height: 2px;
              background: linear-gradient(90deg, #00A0E9 0%, #FFF100 100%);
            
            }
          }
          .mi ~ .line {
            transform: scaleX(3);
            }
          .ri{
            img{
              width: 18px;
              height: 18px;
              cursor: pointer;
            }
          }
        }

      }
    .honor{
        background-color: #fff;
        width: 100%;
        .zhuanli{
          margin-top: 50px;
          .title{
            margin-left: 80px;
            font-size: 16px;
            font-weight: bold;
            color: #333333;
            margin-bottom: 20px;
          }
          .img_com{
            display: flex;
            justify-content: center;
            align-items: center;
            .item{
              margin-right: 7px;
              .img_box{
                width: 129px;
                height: 163px;
                cursor: pointer;
                overflow: hidden;
                img {
                  width: 100%;
                  height: 100%;
                  transition: transform 0.3s ease;
                 }
              }
              &:hover img {
                  transform: scale(1.2); /* 鼠标经过时放大图片 */
                }
              .name{
                text-align: center;
                margin-top: 12px;
              }
            }
          }
        }
        .rongyu{
          margin-bottom: 40px;
          .title{
            font-size: 16px;
            font-weight: bold;
            color: #333333;
            margin-left: 80px;
            margin-top: 30px;
            margin-bottom: 20px;
          }
          .swiper{
            margin: auto;
            .one{
              width: 100%;
              height: 100%;
              .up{
                display: flex;
                justify-content: center;
                margin-bottom: 20px;
                img{
                  width: 161px;
                  height: 127px;
                }
                .mar{
                  margin: 0 28px;
                }
              }
              .lower{
                display: flex;
                justify-content: center;
                img{
                  width: 101px;
                  height: 127px;
                }
                .marr{
                  margin: 0 8px;
                }
              }
            }
            .two{
              width: 100%;
              height: 100%;
              .up{
                display: flex;
                justify-content: center;
                margin-bottom: 20px;
                img{
                  width: 101px;
                  height: 127px;
                }
                .marr{
                  margin: 0 8px;
                }
              }
              .lower{
                display: flex;
                justify-content: center;
                img{
                  width: 161px;
                  height: 127px;
                }
                .mar{
                }
              }
            }
            .el-carousel{
              margin: 0 52px;
              text-align: center;
            }
            :deep(.el-carousel__arrow--left){
              background: #3d9ee7 !important;
            }
            :deep(.el-carousel__arrow--right){
              background: #3d9ee7 !important;
            }
            :deep(.el-carousel__button){
              background-color: #3d9ee7;
            }
          }
        }
      }
    .we{
        width: 100%;
        img{
          width: 100vw;
        }
      }
  }
}
</style>